module.exports = __webpack_public_path__ + "static/media/MichaelMaryanoff_Resume.7af5de2f.pdf";